export enum EnShift {
    all = 'all',
    morning = 'Manhã',
    afternoon = 'Tarde',
    night = 'Noite'
}
